var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"outcome-indicator"}},[(_vm.direction === 'up')?_c('span',{key:'up',staticClass:"indicator up"}):_vm._e(),(_vm.direction === 'down')?_c('span',{key:'down',staticClass:"indicator down"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }